import { DURATION } from '@web-platform/shared-universal-constants/src/queryParams';
import { integerParamParser } from '@web-platform/shared-universal-utils-frontend/src/helpers/queryParams/paramParsers';
import { parseParams } from '@web-platform/shared-universal-utils-frontend/src/helpers/queryParams/parseParams';

import { INITIAL_STATE } from '../duration';

import type { DurationFilterState } from '@web-platform/shared-universal-types/src/redux/state/flightSearchResults/features/filters/duration';

export const getDurationFromUrl = (): DurationFilterState => ({
  ...INITIAL_STATE,
  value: integerParamParser.deserialize(parseParams()[DURATION]),
});
